import ControlButton from './ControlButton';

export default ControlButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/ControlButton/index.js